import { gql } from "@apollo/client";

export const START_NUCLEUS_TURN = gql`
  mutation StartNucleusTurn(
    $threadId: String!
    $contextId: String!
    $runSettings: String!
    $message: String!
    $thinkingEffort: String
    $turnId: String
  ) {
    startNucleusTurn(
      threadId: $threadId
      contextId: $contextId
      runSettings: $runSettings
      message: $message
      thinkingEffort: $thinkingEffort
      turnId: $turnId
    )
  }
`;

export const START_NUCLEUS_TURN_LEGACY = gql`
  mutation StartNucleusTurn(
    $threadId: String!
    $contextId: String!
    $runSettings: String!
    $message: String!
    $thinkingEffort: String
  ) {
    startNucleusTurn(
      threadId: $threadId
      contextId: $contextId
      runSettings: $runSettings
      message: $message
      thinkingEffort: $thinkingEffort
    )
  }
`;

export interface StartNucleusTurnResult {
  startNucleusTurn: boolean;
}

export interface StartNucleusTurnVariables {
  threadId: string;
  contextId: string;
  runSettings: string;
  message: string;
  thinkingEffort?: string | null;
  turnId?: string | null;
}
